module.exports = __webpack_public_path__ + "static/media/primary-teacher.814c6378.jpg";